import React from "react"
import ReactDOM from "react-dom/client"
import "./sass/app.scss"
import Main from "./components/Main"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>
)
